import React, { useEffect, useState } from 'react';
import { Image, message } from 'antd';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import { IComingProps } from 'utils/types/operationTypes';
import { PublicState as PublicStateList } from 'utils/constant';
import { comingSoonApi } from 'apis/operation/comingsoonApis';
import DefaultLayout from 'components/layout/DefaultLayout';
import TableToolbar from 'components/table/TableToolbar';
import SearchInput from 'components/search/SearchInput';
import MainTable from 'components/table/MainTable';
import NoImage from 'components/etc/NoImage';
import CapsuleButton from 'components/button/CapsuleButton';
import DeletePopConfirm from 'components/button/DeletePopConfirm';
import PublicState from 'components/etc/PublicState';
import TextButton from 'components/button/TextButton';
import DefaultButton from 'components/button/DefaultButton';
/**
 * * 운영 관리 - 커밍순 목록
 */

const ComingSoonListPage = () => {
  const publicState = PublicStateList();
  const [cookies] = useCookies();
  const authUpdate = JSON.parse(cookies?.managementAuth);
  const navigate = useNavigate();

  const [searchData, setSearchData] = useState();
  const [comingData, setComingData] = useState<IComingProps[]>();

  const handleLink = (record) => () => {
    navigate(`/comingSoon/${record.comming_id}`, { state: { record: record } });
  };

  const fetchData = async () => {
    const res = await comingSoonApi.read();
    setComingData(res);
  };

  /// 삭제하기
  const handleDelete = (record) => async () => {
    const res = await comingSoonApi.delete(record.comming_id);
    if (!res) {
      return false;
    }

    fetchData();
    message.success('커밍순이 삭제되었습니다.');
  };

  const ColumnsOrigin = [
    {
      title: 'ID',
      dataIndex: 'comming_id',
      width: '5rem',
      align: 'center',
    },
    {
      title: '이미지',
      dataIndex: 'image_url',
      render: (t, record) => (
        <>
          {record.image_url === null || record.image_url === '' ? (
            <NoImage />
          ) : (
            <Image
              src={record.image_url}
              height={40}
              style={{ objectFit: 'contain' }}
            />
          )}
        </>
      ),
    },
    {
      title: '제목',
      dataIndex: 'title',
      sorter: (a, b) => a.title.localeCompare(b.title),
      render: (text, record) => (
        <TextButton onClick={handleLink(record)}>{text}</TextButton>
      ),
    },
    {
      title: '공개 여부',
      dataIndex: 'is_public',
      render: (text) => <PublicState value={text} />,
      filters: publicState,
      onFilter: (value, record) => record?.is_public === value,
    },
    {
      title: '시작일',
      dataIndex: 'from_date',
    },
    {
      title: '종료일',
      dataIndex: 'to_date',
    },
    {
      title: '동작',
      align: 'center',
      render: (text, record, index) => (
        // <div>
        //   <CapsuleButton onClick={handleLink(record)}>수정</CapsuleButton>
        <DeletePopConfirm
          title='해당 커밍순을 삭제하시겠습니까?'
          onConfirm={handleDelete(record)}
          disabled={authUpdate}
        />
        // </div>
      ),
    },
  ];
  useEffect(() => {
    fetchData().catch(console.log);
  }, []);
  return (
    <DefaultLayout>
      <TableToolbar>
        <SearchInput
          placeholder='제목을 입력하세요'
          setSearchData={setSearchData}
        />
        <DefaultButton name='register' onClick={handleLink({ comming_id: 0 })}>
          Coming Soon 등록
        </DefaultButton>
      </TableToolbar>
      <MainTable
        columns={ColumnsOrigin}
        dataSource={
          searchData
            ? comingData?.filter(
                (data) => data.title.indexOf(searchData) !== -1,
              )
            : comingData
        }
      />
    </DefaultLayout>
  );
};

export default ComingSoonListPage;
